import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { config } from "../config";

/**
 * useDashboardSocket - Hook for real-time dashboard updates in Desapedia-WebDesa.
 * 
 * @param {string} ownerId - The tenant/organization ID to listen for.
 * @param {Function} onUpdate - Callback function triggered when data changes.
 *                             Receives { formId, timestamp }.
 */
export const useDashboardSocket = (ownerId, onUpdate) => {
  const socketRef = useRef(null);
  const onUpdateRef = useRef(onUpdate);

  // Update ref setiap kali onUpdate berubah agar callback selalu yang terbaru
  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    if (!ownerId) return;

    let socketUrl;
    try {
      socketUrl = new URL(config.BASE_URL_FORM_DINAMIS).origin;
    } catch (e) {
      console.error("Invalid BASE_URL_FORM_DINAMIS", e);
      return;
    }

    const socket = io(socketUrl, {
      path: "/v1/dynamicformapi/socket.io",
      transports: ["websocket"],
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      socket.emit("join_tenant", ownerId);
    });

    socket.on("connect_error", (err) => {
      console.error(`📡 Dashboard Sync Connection Error:`, err.message);
    });

    socket.on("disconnect", (reason) => {
      console.warn(`📡 Dashboard Sync: Disconnected (${reason})`);
    });

    socket.on("data_updated", (payload) => {
      if (onUpdateRef.current) onUpdateRef.current(payload);
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.off("data_updated"); // Hapus listener spesifik
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [ownerId]); // Hanya re-run jika ownerId berubah

  return socketRef.current;
};
